// ==========================================================================
// AuthProvider — Modality-aware auth router. Picks PhoneAuthGate for the
// PWA flow (OTP / magic link) and TelegramAuthGate for the Mini-App flow
// (initData → Sanctum token). Routes downstream are identical for both.
// ==========================================================================

import { isTelegramWebApp } from '@/lib/platform';
import { PhoneAuthGate } from './PhoneAuthGate';
import { TelegramAuthGate } from './TelegramAuthGate';

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  // Modality decision happens once at render time. The two gates
  // intentionally don't share state — the PWA and Mini-App auth contexts
  // are mutually exclusive within a single tab/session.
  if (isTelegramWebApp()) {
    return <TelegramAuthGate>{children}</TelegramAuthGate>;
  }

  return <PhoneAuthGate>{children}</PhoneAuthGate>;
}

export default AuthProvider;
